import { render } from "./gsrbr0406.vue?vue&type=template&id=01f6a952&scoped=true"
import script from "./gsrbr0406.vue?vue&type=script&lang=js"
export * from "./gsrbr0406.vue?vue&type=script&lang=js"

import "./gsrbr0406.vue?vue&type=style&index=0&id=01f6a952&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01f6a952"]])

export default __exports__